export default {
  blockedNumbers: [],
  searchResult: {},
  status: {}
};